<template>
  <div>
    <v-card class="pb-5">
      <v-data-table
        :headers="headers"
        :items="SData"
        :items-per-page="-1"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Uraian Tugas</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:[`item.nomor`]="{ item }">
          {{
            SData.map(function (x) {
              return x.id;
            }).indexOf(item.id) + 1
          }}
        </template>
        <!-- <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon x-small @click="toSIMASN(item)" v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Salin Data</span>
          </v-tooltip>
        </template> -->
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import SInfojab from "@/store/anjab/infojabatan/infojab";

export default {
  computed: {
    SData: {
      get() {
        return SInfojab.state.tugas;
      },

      set(value) {
        console.log(value);
      },
    },
  },

  data: () => ({
    headers: [
      {
        text: "Nomor",
        value: "nomor",
        width: "50px",
        align: "center",
        sortable: false,
      },
      { text: "Uraian Tugas", align: "start", value: "uraian" },
      // { text: "Action", value: "action", width: "100px", sortable: false },
    ],

    data: [],
  }),
};
</script>
